import { config } from './config/slider'

// todo: check if we need this
// Special Adoption, when the bottom slider is added at the end of the page.
$('.content').each(function() {
    const $this = $(this);

    if ($this.children('.row').length && !$this.children('.row').children().length) {
        $this.addClass('no-child');
    }
});

$('.bottom-slider').slick({
    ...config,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_light_arrowleft.svg" alt="Previous"/></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_light_arrowright.svg" alt="Next"/></button>',
});

